import { PARTITION } from './constants';
import type { ReduxState } from './reducer';

const selectPartition = (state: any): ReduxState => state[PARTITION];

const selectAccountIntent = (state: any) => selectPartition(state) && selectPartition(state).accountIntent;

export default {
  selectPartition,
  selectAccountIntent,
};
